import { useLocation } from "react-router-dom";

export const useTableNameFromURL = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const tableName = query.get("t");
  return tableName == null ? "" : tableName;
};
